import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import * as DOMPurify from "dompurify"

import PageHeader from "../../components/PageHeader"
import { apiBaseURI } from "../../config"
import { fetchChapter } from "../../features/chapter-policy/chapterpolicySlice"
import { Helmet } from "react-helmet-async"

const ChapterPolicy = () => {
    const dispatch = useDispatch()

    const { chapter } = useSelector((state) => state.chapterpolicyPage)

    useEffect(() => {
        dispatch(fetchChapter())
    }, [dispatch])

    let cleanContent = DOMPurify.sanitize(chapter.description)

    const createMarkup = (body) => {
        return { __html: body }
    }

    return (
        <>
            <Helmet>
                <title>{chapter.meta_title}</title>
                <meta name="description" content={chapter.meta_description} />
                <meta name="keywords" content={chapter.meta_keywords} />
            </Helmet>
            <PageHeader
                text={false}
                image={`${apiBaseURI}${chapter.image_url}`}
            />
            <section className="bg-black px-4 py-20 relative">
                <div className="container mx-auto px-6 flex justify-start">
                    <div className=" text-white">
                        <h1 className="font-bold text-3xl md:text-4xl lg:text-5xl">
                            {chapter.title}
                        </h1>
                    </div>
                </div>
            </section>
            <section className="px-4 pt-0 pb-16 bg-blue-dark">
                <div
                    className="container mx-auto relative bg-white -mt-8 p-8 rounded-2xl text-base"
                    dangerouslySetInnerHTML={createMarkup(cleanContent)}
                ></div>
            </section>
        </>
    )
}

export default ChapterPolicy
